export default __webpack_public_path__ + "381475df88e8cb1f89fe0da69cf39717.png";